module.exports = __webpack_public_path__ + "static/img/image18.df9bc707.png";